// ------- 对战相关 --------
import fetch from "./http";

// 初始化
export function battleInit() {
  return fetch({
    url: "/arena/arena-info",
  });
}

// 匹配
export function matchingOp() {
  return fetch({
    url: "/arena/match",
  });
}

// 获取战斗信息
export function startBattle() {
  return fetch({
    url: "/arena/fighting",
  });
}

// 设置出战
export function setTeam(mids) {
  return fetch({
    url: "/arena/fight-monster",
    params: mids,
  });
}

// 排行榜
export function rankList() {
  return fetch({
    url: "/arena/rank-list",
  });
}

// 放弃战斗
export function abandonFight() {
  return fetch({
    url: "/arena/quit-fighting",
  });
}

// 领取每日排行榜奖励
export function dayReword() {
  return fetch({
    url: "/arena/day-rank-reward",
  });
}

// 领取赛季奖励
export function seasonReword() {
  return fetch({
    url: "/arena/season-rank-reward",
  });
}
